import React from 'react'
import './counter.css'

function Counter({title, count, icon}) {
    return (
        <div className="counter">
               <span className="counter-title">
                   {title}
                </span>    
                <span className="counter-title">
                   {count}
                </span>  
        </div>
    )
}

export default Counter
